export { useResultsCard } from './useResultsCard'
